import { TTableProps } from "../types/TableView";
import EmptyState from "../components/EmptyState";
import TableView from "../components/TableView";

const AttributeList = ({
  columns,
  rows,
  showPagination,
  showSearch,
  showPerPage,
  paginationData,
  onPageChange,
  onPerPageChange,
  handleSearchParams,
  searchPlaceholder,
  showFilter,
  filters,
  searchLoading
}: TTableProps) => {
  return (
    <div className="card">
      <TableView
        columns={columns}
        rows={rows}
        showPagination={showPagination}
        showSearch={showSearch}
        showPerPage={showPerPage}
        paginationData={paginationData}
        onPageChange={onPageChange}
        onPerPageChange={onPerPageChange}
        handleSearchParams={handleSearchParams}
        searchPlaceholder={searchPlaceholder}
        searchComponent={<EmptyState                      
          title="Sorry"
          message="No Attribute Found"
          buttonTitle="Reset"
          image="/media/misc/empty-State.svg"
        />}
        showFilter={showFilter}
        filters={filters}
        searchLoading={searchLoading}
        cardHeaderStyle ={"30px"}
      />
    </div>
  );
};

export default AttributeList;
